import React from 'react';
import { CircleIcon, CogIcon, CrosshairIcon, DiscIcon, DropletIcon, FlameIcon, GaugeIcon, Settings2Icon, SnowflakeIcon, ThermometerIcon, WindIcon, WrenchIcon, ZapIcon } from 'lucide-react';
const iconMap: Record<string, React.ComponentType<{
  className?: string;
}>> = {
  gauge: GaugeIcon,
  droplet: DropletIcon,
  disc: DiscIcon,
  crosshair: CrosshairIcon,
  circle: CircleIcon,
  thermometer: ThermometerIcon,
  cog: CogIcon,
  snowflake: SnowflakeIcon,
  zap: ZapIcon,
  flame: FlameIcon,
  settings2: Settings2Icon,
  wind: WindIcon,
  wrench: WrenchIcon
};
export function ServiceCategoryIcon({
  name,
  className = ''
}: {
  name: string;
  className?: string;
}) {
  const Icon = iconMap[name] ?? WrenchIcon;
  return <Icon className={className} data-id="element-342" data-mp="1qn82mllhmi6i" />;
}